import { render, staticRenderFns } from "./NuestrosValores.vue?vue&type=template&id=4822317c&"
import script from "./NuestrosValores.vue?vue&type=script&lang=js&"
export * from "./NuestrosValores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports